// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3rxw2","ranges":"BmiRanges_ranges__2TjuN"};